import useResponsive from "@/hooks/useResponsive";
import {
  Box,
  Container,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { ReactNode } from "react";

interface IProps {
  pt:
    | number
    | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  pb:
    | number
    | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  heading?: string;
  subTitle?: string;
  bgColor?: string;
  children?: ReactNode;
  sectionSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  subtitleSx?: SxProps<Theme>;
}

const Section: React.FC<IProps> = ({
  pt,
  pb,
  heading,
  children,
  subTitle,
  bgColor = "white",
  sectionSx,
  titleSx,
  subtitleSx,
}) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Box
      component="section"
      pt={pt}
      pb={pb}
      bgcolor={bgColor}
      color={theme.palette.text.primary}
      sx={{ ...sectionSx }}
    >
      <Container>
        {heading && (
          <Typography
            color={theme.palette.grey[800]}
            variant="h1"
            mb={isMobile ? 2 : 3}
            sx={{ ...titleSx }}
          >
            {heading}
          </Typography>
        )}
        {subTitle && (
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{ ...subtitleSx }}
          >
            {subTitle}
          </Typography>
        )}

        {children}
      </Container>
    </Box>
  );
};

export default Section;
